import React from 'react';
import Kiosk from './Kiosk';
import { STEPS } from 'utils/kiosk';

/**
 * @param {Object} props - see propTypes
 * @returns {Object} When a kiosk is loaded for a physical location, we do not have any information about which students are
 * signing in at this point (like we would with a virtual check-in), so we begin from the Sign In step.
 */
function PhysicalCheckInContainer(props) {
    return <Kiosk {...props} initialStep={STEPS.SIGN_IN} />
}

export default PhysicalCheckInContainer;
